import EmployerOnboarding from "@container/employer-onboarding";

export default function EmployerSignup() {
  return (
    <EmployerOnboarding />
  );
}
